import axios from 'axios';

const fetchCompanyInfo = async () => {
    const response = await axios.get('/account/api/v1/company');

    return response.data;
};

export default fetchCompanyInfo;